import { render, staticRenderFns } from "./benefits-login-section.vue?vue&type=template&id=7fbf5354&scoped=true"
import script from "./benefits-login-section.vue?vue&type=script&lang=js"
export * from "./benefits-login-section.vue?vue&type=script&lang=js"
import style0 from "./benefits-login-section.vue?vue&type=style&index=0&id=7fbf5354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbf5354",
  null
  
)

export default component.exports